import { render, staticRenderFns } from "./combinationSetting.vue?vue&type=template&id=0c6c8210&scoped=true&"
import script from "./combinationSetting.vue?vue&type=script&lang=js&"
export * from "./combinationSetting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c6c8210",
  null
  
)

export default component.exports